import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faTrashAlt,
	faClose,
	faChevronDown,
	faLink,
} from '@fortawesome/free-solid-svg-icons'

import PopoverButton from '../PopoverButton/index.vue'
import { currencyFormat } from '@/helpers/currency-format'

library.add(faTrashAlt, faClose, faChevronDown, faLink)

@Component({
	components: {
		PopoverButton,
	},
})
export default class CJcpTlp extends Vue {
	@Prop({ default: '#aaa', type: String }) color!: string
	@Prop({ required: true, type: String }) id!: string
	@Prop({ required: true, type: Number }) infoId!: number

	advanced = {
		factor: 0.34,
	}

	money = {
		decimal: ',',
		thousands: '.',
		precision: 2,
		masked: false,
	}

	years = [
		{
			text: '2019',
			jcp: '0',
			aliquot: 0.07,
			tlp: '0',
			balance: '0',
			diff: '0',
		},
		{
			text: '2020',
			jcp: '0',
			aliquot: 0.29,
			tlp: '0',
			balance: '0',
			diff: '0',
		},
		{
			text: '2021',
			jcp: '0',
			aliquot: 1.61,
			tlp: '0',
			balance: '0',
			diff: '0',
		},
		{
			text: '2022',
			jcp: '0',
			aliquot: 1.78,
			tlp: '0',
			balance: '0',
			diff: '0',
		},
		{
			text: '2023',
			jcp: '0',
			aliquot: 1.97,
			tlp: '0',
			balance: '0',
			diff: '0',
		},
	]

	updateSavings(item) {
		const jcpInt = parseFloat(
			item.jcp.replaceAll('.', '').replaceAll(',', '.'),
		)

		const tlp = this.parse((1 + item.aliquot) * jcpInt)
		item.tlp = currencyFormat(tlp)

		item.diff = currencyFormat(this.parse(tlp - jcpInt))
		item.balance = currencyFormat(
			this.parse(jcpInt * item.aliquot * this.advanced.factor),
		)
	}

	get totalBalance() {
		const total = this.years.reduce(function (sum, item) {
			return (
				sum +
				parseFloat(
					item.balance.replaceAll('.', '').replaceAll(',', '.'),
				)
			)
		}, 0)

		this.$emit('savings', total)
		this.$emit('recuperate', total)

		return currencyFormat(total)
	}

	get totalJcp() {
		const total = this.years.reduce(function (sum, item) {
			return (
				sum +
				parseFloat(item.jcp.replaceAll('.', '').replaceAll(',', '.'))
			)
		}, 0)

		return currencyFormat(total)
	}

	get totalTlpSavings() {
		const total = this.years.reduce(function (sum, item) {
			return (
				sum +
				parseFloat(item.tlp.replaceAll('.', '').replaceAll(',', '.'))
			)
		}, 0)

		return currencyFormat(total)
	}

	get totalDiffSavings() {
		const total = this.years.reduce(function (sum, item) {
			return (
				sum +
				parseFloat(item.diff.replaceAll('.', '').replaceAll(',', '.'))
			)
		}, 0)

		return currencyFormat(total)
	}

	get calcsEach() {
		return this.$store.state.calculators.calcsEach
	}

	get calcsPrint() {
		return this.$store.state.calculators.calcsPrint
	}

	parse(n) {
		if (isNaN(n)) return 0
		n = parseFloat(n)
		return parseFloat(n.toFixed(2))
	}

	save() {
		this.savePrint()
		const found = this.calcsEach.find((item) => this.id === item.id)

		if (found) {
			found.years = this.years
			found.factor = this.advanced.factor
		} else {
			this.calcsEach.unshift({
				id: this.id,
				years: this.years,
				factor: this.advanced.factor,
			})
		}
	}

	savePrint() {
		const found = this.calcsPrint.find((item) => this.id === item.id)

		const rows = () => {
			return [
				[
					{
						label: 'JCP - base TJLP Total',
						value: 'R$ ' + this.totalJcp,
					},
					{
						label: 'JCP - base TLP Total',
						value: 'R$ ' + this.totalTlpSavings,
					},
				],
				[
					{
						label: 'Diferença',
						value: 'R$ ' + this.totalDiffSavings,
					},
					{
						label: 'Economia 60 Meses',
						value: 'R$ ' + this.totalBalance,
					},
				],
			]
		}

		if (found) {
			found.rows = rows()
			found.recuperate = this.totalBalance
		} else {
			this.calcsPrint.unshift({
				id: this.id,
				title: 'JCP – Utilização da TLP como índice de cálculo',
				color: this.color,
				columns: 2,
				rows: rows(),
				type: 'table',
				recuperate: this.totalBalance,
				savings: '0',
			})
		}
	}

	created() {
		const found = this.calcsEach.find((item) => this.id === item.id)

		if (found) {
			this.years = found.years
			this.advanced.factor = found.factor
		}
	}
}
